<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import DefaultLayout from './layouts/DefaultLayout.vue'
import EmptyLayout from './layouts/EmptyLayout.vue'

export default {
  components: {
    DefaultLayout,
    EmptyLayout
  },
  computed: {
    layout() {
      const noLayoutPages = ['/giris']
      return noLayoutPages.includes(this.$route.path)
        ? 'EmptyLayout'
        : 'DefaultLayout'
    }
  }
}
</script>
